import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createMetaManager } from "vue-meta";
import "./assets/style.scss";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

createApp(App).use(router).use(createMetaManager()).mount("#app");
